type WidgetPlaceholderProps = {
  height: number;
};

export default function WidgetPlaceholder({
  height,
}: WidgetPlaceholderProps) {
  return (
    <div className="placeholder-glow h-100">
      <span className="placeholder w-100 h-100"></span>
    </div>
  );
}
